import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import store from 'store';
import theme from 'themes';

interface PortalProps {
  id: string;
  content: JSX.Element;
}

export class Portal extends Component<PortalProps> {

  portalRoot?: HTMLElement;
  el = document.createElement('div');

  render() {
    return null;
  }
  
  componentDidMount() {
    const { id } = this.props;
    let p = id && document.getElementById(id);
    if (!p) {
      p = document.createElement('div');
      p.id = id;
      if (document.body) {
        document.body.appendChild(p);
      }
    }
    this.portalRoot = p;
    p.appendChild(this.el);
    this.componentDidUpdate();
  }

  componentWillUnmount() {
    this.portalRoot!.removeChild(this.el);
  }

  componentDidUpdate() {
    const { content } = this.props;
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme}>{content}</ThemeProvider>
      </Provider>,
      this.el
    );
  }
}